<template>
    <div class="login page">
        <login-header />
        <div class="wrapper wrapper--flex">
            <div class="showcase">
                <div v-if="isPartnerApp">
                    <img :src="require(`@webapp/assets/showcase-partner-login.webp`)"
                        class="socios-partner-image"
                        alt="Socios Showcase"
                    >
                    <h2 class="socios-partner-cta">{{ $t('welcomescreen.slides.header1') }}</h2>
                </div>
                <carousel v-else
                    :navigationEnabled="true"
                    navigation-next-label=""
                    navigation-prev-label=""
                    :paginationEnabled="false"
                    :scrollPerPage="false"
                    :perPage="1"
                    class="carousel"
                    @page-change="handleScreenChange"
                >
                    <slide v-for="slide in slides"
                        :key="slide.imagePath"
                        class="slide"
                    >
                        <img class="slide-image"
                            :src="slide.imagePath"
                        >
                        <p class="slide-text">{{ slide.text }}</p>
                    </slide>
                </carousel>
                <download-app v-show="!shouldShowDisabledRegisterWidget"
                    class="showcase__download"
                    :isHorizontal="true"
                />
            </div>
            <div class="login-wrapper">
                <login-widget v-if="!shouldShowDisabledRegisterWidget" />
                <register-widget v-if="shouldShowRegisterWidget" />
                <disabled-register-widget v-if="shouldShowDisabledRegisterWidget" />
            </div>
        </div>
    </div>
</template>

<script>
// Store
import {
    mapGetters,
    mapActions,
} from 'vuex';

// Components
import loginHeader from '@webapp/components/login-process/login-header.vue';
import loginWidget from '@webapp/components/login-process/login-widget.vue';
import registerWidget from '@webapp/components/login-process/register-widget.vue';
import disabledRegisterWidget from '@webapp/components/login-process/disabled-register-widget.vue';
import downloadApp from '@webapp/components/download-app/download-app.vue';
import {
    Carousel,
    Slide,
} from 'vue-carousel';

// Shared Modules
import {
    EventNames,
} from '@shared/utils/analytics-keys';

export default {
    name: 'login',

    components: {
        loginHeader,
        loginWidget,
        registerWidget,
        disabledRegisterWidget,
        downloadApp,
        Carousel,
        Slide,
    },

    props: {
        isRegister: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            registrationDisabledOnWeb: false,
            slides: [
                {
                    imagePath: require('@webapp/assets/walkthrough-screen/slide-1.webp'),
                    text: this.$t('welcomescreen.slides.header1'),
                    visited: false,
                },
                {
                    imagePath: require('@webapp/assets/walkthrough-screen/slide-2.webp'),
                    text: this.$t('welcomescreen.slides.header2'),
                    visited: false,
                },
                {
                    imagePath: require('@webapp/assets/walkthrough-screen/slide-3.webp'),
                    text: this.$t('welcomescreen.slides.header3'),
                    visited: false,
                },
                {
                    imagePath: require('@webapp/assets/walkthrough-screen/slide-4.webp'),
                    text: this.$t('welcomescreen.slides.header4'),
                    visited: false,
                },
            ],
        };
    },
    computed: {
        ...mapGetters([
            'isRegisterWidgetEnabled',
            'isPartnerApp',
        ]),

        shouldShowDisabledRegisterWidget() {
            return (this.isRegister || this.isRegisterWidgetEnabled) && this.registrationDisabledOnWeb;
        },
        shouldShowRegisterWidget() {
            return (this.isRegister || this.isRegisterWidgetEnabled) && !this.registrationDisabledOnWeb;
        },
    },

    mounted() {
        this.setStartedAsGuest(true);

        this.slides[0].visited = true;
        this.$webTrackingInstance?.sendEvent(EventNames.WelcomeScreen1);
    },

    methods: {
        ...mapActions(['setStartedAsGuest']),

        handleScreenChange(index) {
            if (this.slides[index] && !this.slides[index].visited) {
                this.slides[index].visited = true;

                this.$webTrackingInstance?.sendEvent(`Welcome_Screen_${index + 1}`);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.page {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    background-image: url("../assets/walkthrough-screen/background.webp");

    @include max-width(sm) {
        padding-bottom: 0;
    }
}

.wrapper {
    flex: 1;
    max-width: 1200px;

    .main-heading {
        padding: 0 4rem;
        font-size: 1rem;
        line-height: 1.8rem;
        font-weight: 300;
    }
}

.showcase {
    text-align: center;
    display: none;
    width: 100%;
    padding: 0 7rem 0 5rem;

    @include min-width(lg) {
        display: block;
        width: 50%;
        max-width: 550px;
        box-sizing: border-box;
    }

    .socios-partner-image {
        margin-top: 9rem;
    }

    .socios-partner-cta {
        margin-top: 0;
        padding: 0 2rem;
        text-align: center;
        font-family: "Monument", sans-serif;
        text-transform: uppercase;
        font-weight: 800;
        font-size: 2.5rem;
    }

    &__download {
        display: flex;
        justify-content: center;
        padding: 2rem 0 10rem;

        &-logo {
            height: 4.2rem;
            padding: 0 1.75rem;
        }
    }
}

.login-wrapper {
    width: 100%;

    @include min-width(lg) {
        width: 50%;
        box-sizing: border-box;
        margin: 11rem 0;
        flex-wrap: wrap;
        display: flex;
        justify-content: flex-end;
    }

    @include min-width(md) {
        margin-bottom: 6rem;
    }
}

.carousel {
    .slide {
        display: block;
        position: relative;
        width: 200px !important;

        .slide-image {
            width: 100%;
        }

        .slide-text {
            margin-top: 0;
            padding: 0 8rem;
            text-align: center;
            font-family: "Monument", sans-serif;
            text-transform: uppercase;
            font-weight: 800;
            font-size: 2.5rem;
        }
    }
}
</style>